import { render } from "./ProblemSelect.vue?vue&type=template&id=0a85dca8&scoped=true&ts=true"
import script from "./ProblemSelect.vue?vue&type=script&lang=ts"
export * from "./ProblemSelect.vue?vue&type=script&lang=ts"

import "./ProblemSelect.vue?vue&type=style&index=0&id=0a85dca8&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a85dca8"]])

export default __exports__